import { render } from "./BtnChallengeResultsMainAction.vue?vue&type=template&id=7d7dc2f3&scoped=true"
import script from "./BtnChallengeResultsMainAction.vue?vue&type=script&lang=js"
export * from "./BtnChallengeResultsMainAction.vue?vue&type=script&lang=js"

import "@/css/components/btn-challenge-results-main-action.css?vue&type=style&index=0&id=7d7dc2f3&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d7dc2f3"]])

export default __exports__